import { NexusApp } from '@nexus/core-web';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { WEB_MODULES } from './modules';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root in index.html');

createRoot(root).render(
  <StrictMode>
    <NexusApp modules={WEB_MODULES} />
  </StrictMode>,
);
